export const FETCH_LISTINGS = 'shared/artworks/FETCH_LISTINGS';
export const FETCH_ARTWORKS = 'shared/artworks/FETCH_ARTWORKS';
export const RECEIVE_LISTINGS = 'shared/artworks/RECEIVE_LISTINGS';
export const RECEIVE_ARTWORKS = 'shared/artworks/RECEIVE_ARTWORKS';
export const RECEIVE_MORE_ARTWORKS = 'shared/artworks/RECEIVE_MORE_ARTWORKS';
export const CHANGE_CURRENT_LISTING = 'shared/artworks/CHANGE_CURRENT_LISTING';
export const FETCH_ARTWORK = 'shared/artworks/FETCH_ARTWORK';
export const RECEIVE_ARTWORK = 'shared/artworks/RECEIVE_ARTWORK';
export const SET_END_OF_RESULTS = 'shared/artworks/SET_END_OF_RESULTS';
